var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M36,6H12c-3.314,0-6,2.686-6,6v24c0,3.314,2.686,6,6,6h24c3.314,0,6-2.686,6-6V12 C42,8.686,39.314,6,36,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#092347",
    d: "M36,40H12c-2.209,0-4-1.791-4-4V12c0-2.209,1.791-4,4-4h24c2.209,0,4,1.791,4,4v24 C40,38.209,38.209,40,36,40z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.507,15.372c0-0.106,0.077-0.195,0.182-0.207c0.4-0.044,1.516-0.135,3.897-0.135 c3.588,0,6.101,1.423,6.101,5.317c0,3.512-2.391,5.573-6.249,5.573c-0.225,0-0.45,0-1.216,0v5.882c0,0.098-0.08,0.178-0.178,0.178 h-2.358c-0.098,0-0.178-0.08-0.178-0.178V15.372z M17.222,23.447c0,0,1.187,0.008,1.455,0.008c2.203,0,3.205-1.306,3.205-3.056 c0-1.639-0.974-2.917-3.01-2.917c-0.839,0-1.649,0.048-1.649,0.048V23.447z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.156,28.97c0-0.095,0.103-0.154,0.182-0.102c0.504,0.337,1.527,0.914,3.111,0.914 c1.034,0,1.688-0.445,1.688-1.171c0-0.804-1.105-1.387-2.017-1.882c-0.907-0.492-2.944-1.282-2.944-3.826 c0-2.255,1.802-3.615,4.256-3.615c0.94,0,1.977,0.146,2.677,0.401c0.115,0.042,0.185,0.154,0.185,0.277l0,2.291 c0,0.094-0.099,0.155-0.178,0.103c-0.439-0.287-1.407-0.726-2.739-0.726c-1.109,0-1.597,0.54-1.597,1.09 c0,0.964,1.284,1.367,2.436,2.043c1.797,1,2.63,1.977,2.63,3.508c0,2.504-1.867,3.91-4.396,3.91c-1.306,0-2.534-0.285-3.162-0.667 c-0.087-0.053-0.131-0.149-0.131-0.251L26.156,28.97z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPs);
export default __webpack_public_path__ + "static/media/ps.67ff10b1d2305a69ef22448cfc6635d0.svg";
export { ForwardRef as ReactComponent };